exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-center-text[data-v-b2a26320]{\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n.show-check-email-message[data-v-b2a26320] {\n    text-align: center;\n}\n.show-check-email-message[data-v-b2a26320] br {\n    display: inline;\n}\n@media screen and (max-width: 767px) {\n.show-check-email-message[data-v-b2a26320] {\n        text-align: left;\n}\n.show-check-email-message[data-v-b2a26320] br {\n        display: none;\n}\n}\n", ""]);

// exports
